import * as React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker'
import { DateView } from '@mui/x-date-pickers/models'
import { addDays } from 'date-fns'
import { CalendarIcon as DateIcon } from '../icons'
import { theme } from './theme'

const now = new Date()

export interface DatePickerProps {
  value: Date | null | undefined
  onChange: (date: Date, context?: any) => void
  format?: string
  disabled?: boolean
  minDate?: Date
  maxDate?: Date
  views?: DateView[]
  onError?: (errorType: string) => void
  slotProps?: any
  slots?: object
  openTo?: DateView
  placeholder?: string
}

const datePicker =
  (keyboard = false): React.FC<DatePickerProps> =>
  ({
    value,
    onChange,
    format = 'yyyy-MM-dd',
    disabled = false,
    minDate = addDays(now, -100 * 365),
    maxDate = addDays(now, 100 * 365),
    views = ['year', 'month', 'day'],
    onError,
    slots = {},
    slotProps = {},
    placeholder = 'Date',
  }) => {
    const Component = keyboard ? DesktopDatePicker : MobileDatePicker
    const props = {
      value,
      onChange,
      format,
      disabled,
      minDate,
      maxDate,
      views,
      onError,
      slots: {
        ...slots,
        openPickerIcon: DateIcon,
      },
      slotProps: {
        ...slotProps,
        textField: {
          ...slotProps.textField,
          InputLabelProps: { shrink: false },
          inputProps: { placeholder },
          size: 'small',
        },
      },
      dayOfWeekFormatter: (day: string) => day,
    }

    return (
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Component {...props} />
        </LocalizationProvider>
      </ThemeProvider>
    )
  }

export const DatePicker = datePicker()
export const KeyboardDatePicker = datePicker(true)
